<template>
  <div v-if="!loading">
    <div v-if="planner_view">
      <CCard>
        <CTabs :activeTab.sync="activeTab">
          <CTab :title="$t('role.planning.market.tab')">
            <PlanningMarket v-if="activeTab == 0" />
          </CTab>
          <CTab :title="$t('role.planning.wh.tab')">
            <PlanningWh v-if="activeTab == 1" />
          </CTab>
          <CTab :title="$t('role.planning.producer.tab')">
            <PlanningProducer v-if="activeTab == 2" />
          </CTab>
          <CTab :title="$t('role.planning.island.tab')">
            <PlanningIsland v-if="activeTab == 3" />
          </CTab>
          <CTab :title="$t('role.planning.closing.tab')">
            <PlanningClosing
              v-if="activeTab == 4"
              @updateClosingDays="fetchData"
            />
          </CTab>
        </CTabs>
      </CCard>
      <CCard>
        <CCardBody>
          <Planningcalendar />
        </CCardBody>
      </CCard>
    </div>
    <div v-else>
      <CCard>
        <CTabs :activeTab.sync="activeTab">
          <CTab :title="$t('role.planning.calendar.tab')">
            <Planningcalendar v-if="activeTab == 0" />
          </CTab>
          <CTab :title="$t('role.planning.closures.tab')">
            <PlanningClosing
              v-if="activeTab == 1"
              @updateClosingDays="fetchData"
            />
          </CTab>
        </CTabs>
      </CCard>
    </div>
  </div>
  <div
    v-else
    class="d-flex justify-content-center align-items-center"
    style="height: 400px"
  >
    <CSpinner color="primary" />
  </div>
</template>

<script>
import { ROLE_TYPE } from "../../../helpers/acl";
import PlanningProducer from "./PlanningProducer";
import PlanningIsland from "./PlanningIsland";
import PlanningMarket from "./PlanningMarket";
import PlanningWh from "./PlanningWh";
import PlanningTruck from "./PlanningTruck";
import PlanningClosing from "./PlanningClosing";
import Planningcalendar from "./PlanningCalendar";
import { apiGet } from "../../../helpers/apiHelper";

export default {
  name: "ProfileData",
  data() {
    return {
      loading: true,
      activeTab: 0,
      wallet: null,
      role: null,
    };
  },

  async mounted() {
    await this.fetchData();
  },

  methods: {
    async fetchData() {
      const response = await apiGet(
        "auth_frole",
        [],
        this.$store.state.role.id
      );
      if (response && response.status === 200) {
        this.role = response;
        // Update closing_days reactively on the existing role object
        if (response.data.closing_days !== undefined) {
          this.$set(
            this.$store.state.role,
            "closing_days",
            response.data.closing_days
          );
          console.log(
            "store closing_days after update:",
            this.$store.state.role.closing_days
          );
        }
        this.loading = false;
      } else {
        this.$store.dispatch("toaster/add", {
          title: this.$t("role.finance.invoicesSettings.attention"),
          text: "Error loading planning data",
          color: "danger",
          autohide: true,
        });
      }
    },
  },

  computed: {
    planner_view() {
      if (
        [ROLE_TYPE.MARKET, ROLE_TYPE.SHOP].indexOf(
          this.$store.state.role.r_type
        ) > -1
      ) {
        return true;
      }
      return false;
    },
  },

  components: {
    PlanningProducer,
    PlanningIsland,
    Planningcalendar,
    PlanningMarket,
    PlanningWh,
    PlanningTruck,
    PlanningClosing,
  },
};
</script>
